export default "__VITE_PUBLIC_ASSET__cb3397e1__"